import React, { useEffect } from "react";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import "aos/dist/aos.css";
import AOS from "aos";
import "react-accessible-accordion/dist/fancy-example.css";
import "./../../HomePage/Faq/Faq.css";
const AttestationFaqMain = () => {
  useEffect(() => {
    AOS.init({
      duration: 600,
    });
  }, []);
  return (
    <div className="faqMainContainer">
      <Accordion className="faqMainContent" allowZeroExpanded>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>What is document attestation and why is it required?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>

          <AccordionItemPanel className="faqPanel">
            <p>
              Attestation is the process of validating a document’s authenticity
              so it is legally accepted in foreign countries. You need
              attestation for:
              <ul>
                <li> Employment / Job Visa</li>
                <li> Higher Education Abroad</li>
                <li> Family Visa / Spouse Visa</li>
                <li> Migration / Permanent Residency</li>

                <li> Medical Certificate Use Abroad</li>
                <li> Business Setup or Commercial Use</li>
              </ul>
              Without attestation, your documents will not be accepted in the
              destination country.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>What types of documents can be attested?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              In Bangalore, agencies typically attest:
              <li> Educational Certificates (Degree, Diploma, Marksheets)</li>
              <li> Personal Certificates (Birth, Marriage, PCC, Death)</li>
              <li> Commercial Documents (MOA, Invoice, Company agreements)</li>
              <li> Medical, Experience Letters, Salary Certificates</li>
              Each category follows a different attestation process.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>How long does the attestation process take?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Timelines vary by document and destination country:
              <ul>
                <li>
                  {" "}
                  <b>MEA Attestation:</b> 2–5 days
                </li>
                <li>
                  {" "}
                  <b>Embassy Attestation:</b> 3–15 days
                </li>
                <li>
                  {" "}
                  <b>HRD/Home/SDM Attestation:</b> 5–20 days
                </li>
                <li>
                  <b>
                    Gulf Country Attestation (UAE, Qatar, Kuwait, Saudi, Oman):
                  </b>
                  7–20 days
                </li>
              </ul>
              Express/urgent service is available in some cases.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3> What documents are required for attestation? </h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Most attestation processes require:{" "}
              <ul>
                <li> Original Certificate</li>
                <li> Passport copy</li>
                <li> Aadhar/ID proof</li>
                <li> Authorization Letter (for agency submission)</li>
                <li> Transcript/Marksheet (for education attestation)</li>
              </ul>
              Some embassies require additional forms or email verification.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>Is it safe to hand over my original documents?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Yes—ONLY if the agency is Govt-recognized, ISO-certified, and has
              a physical office. A good service provider will give you:
              <ul>
                <li> Receipt for originals</li>
                <li> Live tracking</li>
                <li> Written timeline</li>
                <li> Customer support</li>
              </ul>
              Avoid freelancers and unregistered agents.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>What are the steps involved in the attestation process?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              A typical attestation flow includes:
              <br />
              <b>Educational Docs:</b>
              <ul>
                <li> University Verification</li>
                <li> HRD/SDM Attestation</li>
                <li> MEA Attestation</li>
                <li> Embassy Attestation</li>
                <li> MOFA/Consulate Attestation (destination country)</li>
              </ul>
              <br />
              <b>Personal Docs:</b>
              <ul>
                {" "}
                <li> Notary</li>
                <li> SDM/Home Dept</li>
                <li> MEA</li>
                <li> Embassy</li>
                <li> MOFA</li>
              </ul>
              Each step verifies authenticity at a different authority level.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>Can the attestation be done without visiting the office?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Yes. Most professional agencies in Bangalore offer:
              <ul>
                <li> Free home pickup & delivery</li>
                <li> Online payment</li>
                <li> WhatsApp updates</li>
                <li> Full remote process</li>
              </ul>
              Ideal for working professionals or people who travel.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>How much does attestation cost in Bangalore? </h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Prices depend on:
              <ul>
                <li> Document type</li>
                <li> Government fees</li>
                <li> Embassy fees</li>
                <li> Courier charges</li>
                <li> Urgency/express service</li>
              </ul>
              Typical ranges:
              <ul>
                <li>
                  {" "}
                  <b>Education Attestation:</b> ₹3,000–₹15,000
                </li>
                <li>
                  {" "}
                  <b>Personal Docs:</b> ₹2,000–₹10,000
                </li>
                <li>
                  {" "}
                  <b>Commercial Docs:</b> ₹5,000–₹30,000
                </li>
              </ul>
              Always ask for an itemized breakdown.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>How do I know if my document is eligible for attestation?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              You must check:
              <ul>
                <li> Non-laminated original certificate</li>
                <li>Correct name as per passport</li>
                <li> Proper seals/signatures from university/authority</li>
                <li> Valid government-issued certificate</li>
              </ul>
              Laminated or damaged documents may be rejected.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>Can attestation be rejected? What causes rejection?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Yes. Common reasons include:
              <ul>
                <li> Mismatch in name between certificate & passport</li>
                <li> Fake or unverifiable documents</li>
                <li> Missing university seals</li>
                <li> Laminated certificates</li>
                <li> Incomplete supporting documents</li>
                <li> Non-UGC/AICTE approved university (for education)</li>
              </ul>
              A reliable agency will pre-check documents to prevent rejection.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
      </Accordion>
    </div>
  );
};

export default AttestationFaqMain;
